/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_ROADBORDERCROSS_SCHEMA = Yup.object().shape({
    //general section Rules:
    nameResp: Yup.string("nameResp Is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("tent category is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),

    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
            if (value === null) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

            for (const email of emails) {
                if (!emailRegex.test(email.trim())) {
                    throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    tenTCategory: Yup.string("Road ID is alphanumeric").nullable(true),
    borderCrossName: Yup.number("Must be a number").nullable(true),
    routeId: Yup.string("Road ID is alphanumeric").nullable(true),
    owner1: Yup.string("Road ID is alphanumeric").nullable(true),
    owner1Per: Yup.string("Route Id").nullable(true),
    ownerOther: Yup.string("Road ID is alphanumeric").nullable(true),
    ownerOtherPer: Yup.string("Road ID is alphanumeric").nullable(true),
    dateValidFrom: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidTo: Yup.date("Valid to is a Date").required().nullable(true),
    dateValidFor: Yup.string("Valid for is a Year"),
    greenLanes: Yup.string("Road ID is alphanumeric").nullable(true),
    oneStopProcedure: Yup.string("Road ID is alphanumeric").nullable(true),
    oneStopProcedureType: Yup.string("GreenLanes Is alphanumeric").nullable(true),
    contolType: Yup.string("oneStopProcedure Is alphanumeric").nullable(true),
    borderWith: Yup.string("oneStopProcedureType Is alphanumeric").nullable(true),
    remarks: Yup.string("description").required("Required Description").nullable(true),

    RoadsBorderCrossingNpmInfraDTO: Yup.object().shape({
        lanesTrucksEntering: Yup.number('Value should be number').nullable(true),
        lanesTrucksExiting: Yup.number('Value should be number').nullable(true),
        lanesBusesEntering: Yup.number('Value should be number').nullable(true),
        lanesBusesExiting: Yup.number('Value should be number').nullable(true),
        numLanesPassEntering: Yup.number('Value should be number').nullable(true),
        numLanesPassExiting: Yup.number('Value should be number').nullable(true),
        trucksSepParkingZones: Yup.boolean().nullable(true),
        truckParkingCapacity: Yup.number('Value should be number').nullable(true),
        truckQueuingCapacity: Yup.number('Value should be number').nullable(true),
        statePlayBooth: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        statePlayDataSystem: Yup.number('Value should be number').nullable(true),
        statePlayPhisInspFaci: Yup.boolean().nullable(true),
        seed: Yup.string("description").nullable(true),
        ncts: Yup.string("description").nullable(true),
        otherElectronicIs: Yup.string("description").nullable(true),
        typeItsInst: Yup.string("description").nullable(true),
        remarks: Yup.string("description").nullable(true)
    }),

    RoadsBorderCrossingNpmOperDTO: Yup.object().shape({
        passengerCarsEnt: Yup.number('Value should be number').nullable(true),
        bussesEnt: Yup.number('Value should be number').nullable(true),
        freightVehEnt: Yup.number('Value should be number').nullable(true),
        dangerousGoodsVehEnt: Yup.number('Value should be number').nullable(true),
        passengerCarsAveWTime: Yup.number('Value should be number').nullable(true),
        freightVehAveWTime: Yup.number('Value should be number').nullable(true),
        bussesAveWTime: Yup.number('Value should be number').nullable(true),
        passengerCarsAveDur: Yup.number('Value should be number').nullable(true),
        freightVehAveDur: Yup.number('Value should be number').nullable(true),
        bussesAveDur: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        freightVehClearCustBcp: Yup.number('Value should be number').nullable(true),
        freightVehEnterImp: Yup.number('Value should be number').nullable(true),
        freightVehEnterTransit: Yup.number('Value should be number').nullable(true),
        freightVehEnterEmpty: Yup.number('Value should be number').nullable(true),
        passengerCarsExit: Yup.number('Value should be number').nullable(true),
        bussesExit: Yup.number('Value should be number').nullable(true),
        freightVehExit: Yup.number('Value should be number').nullable(true),
        dangerousGoodsVehExit: Yup.number('Value should be number').nullable(true),
        passengerCarsExitAveWTime: Yup.number('Value should be number').nullable(true),
        freightVehExitAveWTime: Yup.number('Value should be number').nullable(true),
        bussesExitAveDur: Yup.number('Value should be number').nullable(true),
        reqUpgradeIncCapacity: Yup.boolean().nullable(true),
        reqUpgradeIts: Yup.boolean().nullable(true),
        remarks: Yup.string("description").nullable(true)
    })
});
const ROADBORDERCROSS_INIT = {
    //general section Rules:
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    tenTCategory: "",
    borderCrossName: "",
    routeId: "",
    owner1: "",
    owner1Per: "",
    ownerOther: "",
    ownerOtherPer: "",
    dateValidFrom: "",
    dateValidTo: "",
    dateValidFor: "",
    greenLanes: "",
    oneStopProcedure: "",
    oneStopProcedureType: "",
    contolType: "",
    borderWith: "",
    remarks: "",
    RoadsBorderCrossingNpmInfraDTO: {
        lanesTrucksEntering: 0,
        lanesTrucksExiting: 0,
        lanesBusesEntering: 0,
        lanesBusesExiting: 0,
        numLanesPassEntering: 0,
        numLanesPassExiting: 0,
        trucksSepParkingZones: false,
        truckParkingCapacity: 0,
        truckQueuingCapacity: 0,
        statePlayBooth: 0,
        statePlayDataSystem: 0,
        statePlayPhisInspFaci: false,
        seed: "",
        ncts: "",
        otherElectronicIs: "",
        typeItsInst: "",
        remarks: ""
    },
    RailwaysBorderCrossingNpmOper: {
        passengerCarsEnt: 0,
        bussesEnt: 0,
        freightVehEnt: 0,
        dangerousGoodsVehEnt: 0,
        passengerCarsAveWTime: 0,
        freightVehAveWTime: 0,
        bussesAveWTime: 0,
        passengerCarsAveDur: 0,
        freightVehAveDur: 0,
        bussesAveDur: 0,
        freightVehClearCustBcp: 0,
        freightVehEnterImp: 0,
        freightVehEnterTransit: 0,
        freightVehEnterEmpty: 0,
        passengerCarsExit: 0,
        bussesExit: 0,
        freightVehExit: 0,
        dangerousGoodsVehExit: 0,
        passengerCarsExitAveWTime: 0,
        freightVehExitAveWTime: 0,
        bussesExitAveDur: 0,
        reqUpgradeIncCapacity: false,
        reqUpgradeIts: false,
        remarks: ""
    }
}

export { TODIS_ROADBORDERCROSS_SCHEMA, ROADBORDERCROSS_INIT };